export enum BookingType {
  Status = 'active',
  BookingNumber = 'id'
}